<script>
  import { getBannersContext } from '@client/components/banners';

  const { addBanner } = getBannersContext();

  export let config = {};

  addBanner(config);
</script>
